import { render, staticRenderFns } from "./CatalogLoader.vue?vue&type=template&id=33e6bee5"
import script from "./CatalogLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogLoader.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports